export default "__VITE_ASSET__DOmpGxXs__"